document.addEventListener('DOMContentLoaded', () => {

  const observer = new MutationObserver((mutations, obs) => {
    const accept = document.querySelector('.iubenda-cs-accept-btn');
    const accept_all = document.querySelector('.iub-btn-accept');
    const save = document.querySelector('#iubFooterBtn');

    const reject_all = document.querySelector('.iub-btn-reject');

    if (accept) {
      accept.addEventListener('click', () => {
        allowShopifyPreferencesOnly(true);
      });
    }

    if (reject_all) {
      reject_all.addEventListener('click', () => {
        if (save) {
          save.replaceWith(save.cloneNode(true)); // rimuove tutti i listener esistenti
          const newSave = document.querySelector('#iubFooterBtn');
          newSave.addEventListener('click', () => allowShopifyPreferencesOnly(false));
        }
      });
    }

    if (accept_all) {
      accept_all.addEventListener('click', () => {
        if (save) {
          save.replaceWith(save.cloneNode(true)); // rimuove tutti i listener esistenti
          const newSave = document.querySelector('#iubFooterBtn');
          newSave.addEventListener('click', () => allowShopifyPreferencesOnly(true));
        }
      });
    }

    if (accept || accept_all || save) {
      obs.disconnect();
    }

    searchWishlistPage();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  function allowShopifyPreferencesOnly(allow) {
    if (!window.Shopify?.customerPrivacy?.setTrackingConsent) {
      console.warn('Shopify.customerPrivacy non è disponibile ancora.');
      return;
    }

    const currentAnalytics = typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function'
      ? Shopify.customerPrivacy.analyticsProcessingAllowed()
      : false;

    const currentMarketing = typeof Shopify.customerPrivacy.marketingProcessingAllowed === 'function'
      ? Shopify.customerPrivacy.marketingProcessingAllowed()
      : false;

    Shopify.customerPrivacy.setTrackingConsent({
      analytics: currentAnalytics,
      marketing: currentMarketing,
      preferences: allow
    });

    updateWishlistButtons();
  }

  function searchWishlistPage() {
    const accept = document.querySelector('#accept-cookie');
    const reject = document.querySelector('#reject-cookie');

    if (!accept || !reject || !window.Shopify?.customerPrivacy) return;

    let lastState = null;

    function updateButtons() {
      const preferencesAllowed = typeof Shopify.customerPrivacy.preferencesProcessingAllowed === 'function'
        ? Shopify.customerPrivacy.preferencesProcessingAllowed()
        : false;

      if (preferencesAllowed !== lastState) {
        lastState = preferencesAllowed;

        const displayAccept = preferencesAllowed ? 'block' : 'none';
        const displayReject = preferencesAllowed ? 'none' : 'block';

        if (accept) accept.style.display = displayAccept;
        if (reject) reject.style.display = displayReject;
      }
    }

    window.updateWishlistButtons = updateButtons;

    const interval = setInterval(updateButtons, 500);
  }

  function updateWishlistButtons() {
    if (window.updateWishlistButtons) {
      window.updateWishlistButtons();
    }
  }

});
